/**
 * Action Types
 */

import {
  MODAL_OPEN,
  MODAL_CLOSE
} from 'redux-types/modal'

const initialState = {
  is_open: false,
  tag: null,
  data: null
}

export default function modal_reducer (state = initialState, action) {
  switch (action.type) {
    case MODAL_OPEN:
      return {
        ...state,
        is_open: true,
        tag: action.tag,
        data: action.data || state.data
      }

    case MODAL_CLOSE:
      return {
        ...state,
        is_open: false,
        tag: null,
        data: action.keep_data ? state.data : null
      }

    default:
      return state
  }
}
